<div class="complete-dialog-container">
    <div class="complete-dialog-header">
        <h5>Complete RFQ Summary evaluation</h5>
    </div>
    <div *ngIf="!isAllItemsHavePO else allItemsHavePO">
        <span>The following items have not been raised in a PO. Please select the reason for aborting these
            items.</span>
        <br />
        <span>If you want to purchase these items, please close this dialog and raise PO accordingly.</span>
        <div class="reason-section">
            <br />
            <span>Reason for aborting selected item(s)</span>
            <div class="reason-container">
                <ng-select class="dropdown" [items]="ReasonForAbortionDropDown" bindLabel="Name" bindValue="Id"
                    appearance="outline" [appendTo]="'body'" (change)="onAbortReasonSelected($event)"
                    dropdownPosition="bottom" placeholder="Please select an option">
                </ng-select>
                <app-button class="apply-btn" name="Apply to checked items" (click)="onApplyButtonClick()"></app-button>
            </div>
            <shared-alert [type]="alertType.Error" *ngIf="isAnyItemSelectedForReasonForAbortion === false">
                <span alert-content>
                    Please use the checkbox to select item(s) that you would like to assign reason to.
                </span>
            </shared-alert>
            <shared-alert [type]="alertType.Error" *ngIf="allItemsHaveReason === false">
                <span alert-content>
                    Please provide a reason for all items.
                </span>
                <!-- insert a break here. -->
                <span alert-content>
                    Use the checkbox to select item(s) and the dropdown field to select a reason. 
                    Click "Apply to checked items" to assign the selected reason to the checked items.
                </span>
            </shared-alert>
            <!-- Please change the filteredItemsWithoutPO to rfqItems for future testing. For production, please use filteredItemsWithoutPO -->
            <app-item-selection-listing [selectionMode]="true" [list]="filteredItemsWithoutPO" [type]="type"
                [selectedReasonForAbort]="selectedReasonForAbort" (selected)="handleSelection($event)"
                [mpMmsInformation]="mpMmsInformation"
                (allItemsHavePoChange)="updateAllItemsHavePO($event)" />
        </div>
    </div>
    <div class="button-container">
        <app-button class="padBtn mar-r-10" (click)="onCancel()" [name]="'Cancel'"></app-button>
        <app-button class="padBtn mar-r-10" (click)="onComplete()" [name]="'Complete'" type="flat-button"></app-button>
    </div>

    <ng-template #allItemsHavePO>
        <br />
        <span>Proceed if you have finished evaluating this RFQ Summary.</span>
        <br />
        <span>This action cannot be undone.</span>
        <br />
    </ng-template>
</div>